'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dKind from "./app.data.-App-Document-Kind.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentData() {
}
export { $c_Lapp_data_AppDocumentData as $c_Lapp_data_AppDocumentData };
$p = $c_Lapp_data_AppDocumentData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentData;
/** @constructor */
function $h_Lapp_data_AppDocumentData() {
}
export { $h_Lapp_data_AppDocumentData as $h_Lapp_data_AppDocumentData };
$h_Lapp_data_AppDocumentData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.yy = (function() {
  return this.vQ().yy();
});
$p.Wh = (function() {
  return this.vQ().Wh();
});
$p.ur = (function() {
  if ((this instanceof $c_Lapp_data_AppDocumentData$PurchaseOrder)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__PurchaseOrder__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$Invoice)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__Invoice__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$CertificateOfOrigin)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__CertificateOfOrigin__Lapp_data_AppDocumentKind();
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$CreditNote)) {
    return $j_app$002edata$002e$002dApp$002dDocument$002dKind.$s_Lapp_data_AppDocumentKind$__CreditNote__Lapp_data_AppDocumentKind();
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
$p.bwz = (function() {
  if ((this instanceof $c_Lapp_data_AppDocumentData$PurchaseOrder)) {
    return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$PurchaseOrder(this.Bp.bXN());
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$Invoice)) {
    return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$Invoice(this.Bo.bXM());
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$CertificateOfOrigin)) {
    return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin(this.EQ.bXK());
  }
  if ((this instanceof $c_Lapp_data_AppDocumentData$CreditNote)) {
    return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CreditNote(this.ER.bXL());
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_data_AppDocumentData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dB)));
}
export { $isArrayOf_Lapp_data_AppDocumentData as $isArrayOf_Lapp_data_AppDocumentData };
/** @constructor */
function $c_Lapp_data_AppDocumentData$CertificateOfOrigin(data) {
  this.EQ = null;
  this.EQ = data;
}
export { $c_Lapp_data_AppDocumentData$CertificateOfOrigin as $c_Lapp_data_AppDocumentData$CertificateOfOrigin };
$p = $c_Lapp_data_AppDocumentData$CertificateOfOrigin.prototype = new $h_Lapp_data_AppDocumentData();
$p.constructor = $c_Lapp_data_AppDocumentData$CertificateOfOrigin;
/** @constructor */
function $h_Lapp_data_AppDocumentData$CertificateOfOrigin() {
}
export { $h_Lapp_data_AppDocumentData$CertificateOfOrigin as $h_Lapp_data_AppDocumentData$CertificateOfOrigin };
$h_Lapp_data_AppDocumentData$CertificateOfOrigin.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentData$CertificateOfOrigin)) {
    var x = this.EQ;
    var x$2 = x$0.EQ;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "CertificateOfOrigin";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.EQ;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 2;
});
$p.vQ = (function() {
  return this.EQ;
});
function $isArrayOf_Lapp_data_AppDocumentData$CertificateOfOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iI)));
}
export { $isArrayOf_Lapp_data_AppDocumentData$CertificateOfOrigin as $isArrayOf_Lapp_data_AppDocumentData$CertificateOfOrigin };
var $d_Lapp_data_AppDocumentData$CertificateOfOrigin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$CertificateOfOrigin, "app.data.AppDocumentData$CertificateOfOrigin", ({
  iI: 1,
  dB: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentData$CertificateOfOrigin as $d_Lapp_data_AppDocumentData$CertificateOfOrigin };
/** @constructor */
function $c_Lapp_data_AppDocumentData$CreditNote(data) {
  this.ER = null;
  this.ER = data;
}
export { $c_Lapp_data_AppDocumentData$CreditNote as $c_Lapp_data_AppDocumentData$CreditNote };
$p = $c_Lapp_data_AppDocumentData$CreditNote.prototype = new $h_Lapp_data_AppDocumentData();
$p.constructor = $c_Lapp_data_AppDocumentData$CreditNote;
/** @constructor */
function $h_Lapp_data_AppDocumentData$CreditNote() {
}
export { $h_Lapp_data_AppDocumentData$CreditNote as $h_Lapp_data_AppDocumentData$CreditNote };
$h_Lapp_data_AppDocumentData$CreditNote.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentData$CreditNote)) {
    var x = this.ER;
    var x$2 = x$0.ER;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "CreditNote";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.ER;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 3;
});
$p.vQ = (function() {
  return this.ER;
});
function $isArrayOf_Lapp_data_AppDocumentData$CreditNote(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iJ)));
}
export { $isArrayOf_Lapp_data_AppDocumentData$CreditNote as $isArrayOf_Lapp_data_AppDocumentData$CreditNote };
var $d_Lapp_data_AppDocumentData$CreditNote = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$CreditNote, "app.data.AppDocumentData$CreditNote", ({
  iJ: 1,
  dB: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentData$CreditNote as $d_Lapp_data_AppDocumentData$CreditNote };
/** @constructor */
function $c_Lapp_data_AppDocumentData$Invoice(data) {
  this.Bo = null;
  this.Bo = data;
}
export { $c_Lapp_data_AppDocumentData$Invoice as $c_Lapp_data_AppDocumentData$Invoice };
$p = $c_Lapp_data_AppDocumentData$Invoice.prototype = new $h_Lapp_data_AppDocumentData();
$p.constructor = $c_Lapp_data_AppDocumentData$Invoice;
/** @constructor */
function $h_Lapp_data_AppDocumentData$Invoice() {
}
export { $h_Lapp_data_AppDocumentData$Invoice as $h_Lapp_data_AppDocumentData$Invoice };
$h_Lapp_data_AppDocumentData$Invoice.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentData$Invoice)) {
    var x = this.Bo;
    var x$2 = x$0.Bo;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Invoice";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Bo;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
$p.vQ = (function() {
  return this.Bo;
});
function $isArrayOf_Lapp_data_AppDocumentData$Invoice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iK)));
}
export { $isArrayOf_Lapp_data_AppDocumentData$Invoice as $isArrayOf_Lapp_data_AppDocumentData$Invoice };
var $d_Lapp_data_AppDocumentData$Invoice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$Invoice, "app.data.AppDocumentData$Invoice", ({
  iK: 1,
  dB: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentData$Invoice as $d_Lapp_data_AppDocumentData$Invoice };
/** @constructor */
function $c_Lapp_data_AppDocumentData$PurchaseOrder(data) {
  this.Bp = null;
  this.Bp = data;
}
export { $c_Lapp_data_AppDocumentData$PurchaseOrder as $c_Lapp_data_AppDocumentData$PurchaseOrder };
$p = $c_Lapp_data_AppDocumentData$PurchaseOrder.prototype = new $h_Lapp_data_AppDocumentData();
$p.constructor = $c_Lapp_data_AppDocumentData$PurchaseOrder;
/** @constructor */
function $h_Lapp_data_AppDocumentData$PurchaseOrder() {
}
export { $h_Lapp_data_AppDocumentData$PurchaseOrder as $h_Lapp_data_AppDocumentData$PurchaseOrder };
$h_Lapp_data_AppDocumentData$PurchaseOrder.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentData$PurchaseOrder)) {
    var x = this.Bp;
    var x$2 = x$0.Bp;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "PurchaseOrder";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Bp;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
$p.vQ = (function() {
  return this.Bp;
});
function $isArrayOf_Lapp_data_AppDocumentData$PurchaseOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iL)));
}
export { $isArrayOf_Lapp_data_AppDocumentData$PurchaseOrder as $isArrayOf_Lapp_data_AppDocumentData$PurchaseOrder };
var $d_Lapp_data_AppDocumentData$PurchaseOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$PurchaseOrder, "app.data.AppDocumentData$PurchaseOrder", ({
  iL: 1,
  dB: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentData$PurchaseOrder as $d_Lapp_data_AppDocumentData$PurchaseOrder };
//# sourceMappingURL=app.data.-App-Document-Data.js.map
